import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Special Recognition Award section for selections tab
 */
const InvestorRelationsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="special-recognition-award-section-component"
    >
      <AccordionV2
        testId="special-recognition-award"
        className="border-l border-r py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Special Recognition Award" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 pt-4">
          <p>
            There will be a call for nominations from the corporate community at
            large.
          </p>

          <p>
            Nominations are to be sent to the Singapore Corporate Awards
            Secretariat. Nominations are in free form but should provide the
            name and contact information of the nominator, a seconder, and the
            name and any supporting information of the nominee. Self-nominations
            are allowed.
          </p>

          <p>
            In addition to the nominations submitted, other candidates may be
            identified by the Singapore Corporate Awards Secretariat through
            industry knowledge and media.
          </p>

          <p>
            The SCA Steering Committee will then review all nominations and
            decide on who or which organisations are deserving of the award.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default InvestorRelationsSection;
